import React from "react";
import Select from "react-select";

export function DeletedFilter({ value, onChange, includeAll = false }) {
  const options = includeAll
    ? [
        { value: "all", label: "All" },
        { value: "no", label: "No" },
        { value: "yes", label: "Yes" },
      ]
    : [
        { value: "no", label: "No" },
        { value: "yes", label: "Yes" },
      ];

  const currentLabel =
    value === "yes" ? "Yes" : value === "no" ? "No" : "All";

  return (
    <div className="col-md-3">
      <div className="mb-3">
        <label className="form-label" htmlFor="deleted_filter">
          Deleted
        </label>
        <Select
          menuPortalTarget={document.body}
          styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          name="deleted_filter"
          inputId="deleted_filter"
          options={options}
          value={{ value, label: currentLabel }}
          onChange={(selected) => onChange(selected?.value || (includeAll ? "all" : "no"))}
        />
      </div>
    </div>
  );
}

export function RestoreAction({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="badge bg-label-success border-0"
      style={{ cursor: "pointer" }}
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title="Restore"
      data-bs-original-title="Restore"
    >
      <i className="bx bx-revision"></i>
    </button>
  );
}
